var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H8C3.8585 0 0.5 3.42514 0.5 7.64881V29.0655C0.5 33.2892 3.8585 36.7143 8 36.7143H29C33.143 36.7143 36.5 33.2892 36.5 29.0655V7.64881C36.5 3.42514 33.143 0 29 0ZM12.5 29.0655H8V12.2381H12.5V29.0655ZM10.25 10.2984C8.801 10.2984 7.625 9.08984 7.625 7.59986C7.625 6.10987 8.801 4.90136 10.25 4.90136C11.699 4.90136 12.875 6.10987 12.875 7.59986C12.875 9.08984 11.7005 10.2984 10.25 10.2984ZM30.5 29.0655H26V20.4927C26 15.3405 20 15.7305 20 20.4927V29.0655H15.5V12.2381H20V14.9381C22.094 10.9822 30.5 10.69 30.5 18.7258V29.0655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer1.c22ef6914128e74a646cd149d2a50626.svg";
export { ForwardRef as ReactComponent };